/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import AnalyticsService from 'cio/services/analytics';
import RouterService from '@ember/routing/router-service';
import SegmentModel from 'cio/models/segment';
import { formTypeLabel } from 'cio/utils/forms';

interface SegmentHeaderLinkedFormReadonlyTooltipArgs {
  segment: SegmentModel;
}

export default class SegmentHeaderLinkedFormReadonlyTooltip extends Component<SegmentHeaderLinkedFormReadonlyTooltipArgs> {
  @service analytics!: AnalyticsService;
  @service router!: RouterService;

  @action
  duplicateSegment(e: Event) {
    e.preventDefault();

    let { segment } = this.args;

    this.analytics.track('segment', 'duplicated', { model: segment });
    this.router.transitionTo('segments.new', { queryParams: { referenceSegmentId: segment.id } });
  }

  get formTypeLabel() {
    return formTypeLabel(this.args.segment.linkedFormType) ?? '';
  }
}
